export default class EventAdapter {
  constructor(achievementEvent) {
    let NUMBEROFDAYSTAKINGTODAY = 2

    this.eventId = achievementEvent.eventId
    this.daysToExpiry = achievementEvent.daysToExpiry + NUMBEROFDAYSTAKINGTODAY
    this.daysToStart = Math.abs(achievementEvent.daysToStart)
    this.description = achievementEvent.description
    this.eventName = achievementEvent.eventName
    this.imageName = achievementEvent.imageUrl
    this.progress = achievementEvent.progress
    this.totalToComplete = achievementEvent.totalToComplete
    this.isCompleted = achievementEvent.progress === achievementEvent.totalToComplete
    this.rewardWasCollected = achievementEvent.rewardWasCollected
  }
}
